<ng-container *ngIf="authorization; else noAuth">
<app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

<div class="form" style="padding-bottom: 70px; max-width: 1200px">
  <div style="padding: 20px 30px;">
    <h3 style="text-align: center">Work Productivity and Activity Impairment Questionnaire(WPAI) </h3>
    <hr>
    <h4>Istruzioni: Le domande che seguono intendono determinare gli effetti della malattia infiammatoria cronica intestinale sulla sua capacità di lavorare e svolgere le normali attività quotidiane. La preghiamo di riempire gli spazi vuoti o selezionare un numero, come indicato in alcune domande. </h4>
  </div>
  <form [formGroup]="qForm" (ngSubmit)="onSubmit()">

    <div class="container mat-elevation-z5">

      <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.position}} </td>
        </ng-container>


        <ng-container matColumnDef="question">
          <th mat-header-cell *matHeaderCellDef> Domanda </th>
          <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.question}}
            <ng-container *ngIf="questionnaire.position == 1">
              <br><br><strong>Se la risposta è NO, contrassegni il "NO" e passi alla domanda 6. Le domande che seguono si riferiscono agli ultimi sette giorni, esclusa la giornata di oggi.</strong>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 2 || questionnaire.position == 3 || questionnaire.position == 4">
              <br><br><strong>Scriva un valore nella casella alla sua destra</strong>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 5">
              <br><br><strong>Se la malattia infiammatoria cronica intestinale ha inciso poco sul suo lavoro, scelga un numero basso. Scelga invece un numero alto se la malattia infiammatoria cronica intestinale ha inciso molto sul suo lavoro. Consideri solamente in che misura la malattia infiammatoria cronica intestinale ha inciso sulla sua produttività durante il lavoro.</strong>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 6">
              <br><br><strong>Se la malattia infiammatoria cronica intestinale ha inciso poco sulle sue attività, scelga un numero basso. Scelga invece un numero alto se la malattia infiammatoria cronica intestinale ha inciso molto sulle sue attività. Consideri solamente in che misura la malattia infiammatoria cronica intestinale ha inciso sulla sua capacità di svolgere le normali attività giornaliere, escluso il lavoro.</strong>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef> Valore </th>
          <td mat-cell *matCellDef="let questionnaire">
              <ng-container *ngIf="questionnaire.position === 1">
              <mat-form-field>
              <mat-label>Seleziona un valore</mat-label>
              <mat-select required>
                  <mat-option *ngFor="let value of answers" [value]="value"
                              (onSelectionChange)="selectResult($event, value, questionnaire.position)">
                    {{value}}
                  </mat-option>
              </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 2 || questionnaire.position == 3">
              <mat-form-field>
                <mat-label>Inserisci il numero di ore</mat-label>
                <input matInput type="number" (change)="setResult(questionnaire.position)"
                       formControlName="{{q+questionnaire.position}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
                  <ng-container *ngIf="qForm.get(q+questionnaire.position).hasError('min') && notFocused">
                    <div>
                    <span class="error">
                      Inserisci un numero valido
                    </span>
                    </div>
                  </ng-container>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 4">
              <mat-form-field>
                <mat-label>Inserisci il numero di ore</mat-label>
                <input matInput type="number" (change)="setDisabled5(questionnaire.position)"
                       formControlName="{{q+questionnaire.position}}" (focusin)="notFocused=false" (focusout)="notFocused=true">
              </mat-form-field>
              <ng-container *ngIf="qForm.get(q+questionnaire.position).hasError('min') && notFocused">
                <div>
                    <span class="error">
                      Inserisci un numero valido
                    </span>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 5">
              <mat-form-field>
              <mat-label>Seleziona un valore</mat-label>
              <mat-select required [disabled]="isDisabled || isDisabled5">
              <mat-option *ngFor="let value of values" [value]="value"
                          (onSelectionChange)="selectResult($event, value, questionnaire.position)">
                {{value}}
              </mat-option>
              </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-container *ngIf="questionnaire.position == 6">
              <mat-form-field>
                <mat-label>Seleziona un valore</mat-label>
                <mat-select required>
                  <mat-option *ngFor="let value of values" [value]="value"
                              (onSelectionChange)="selectResult($event, value, questionnaire.position)">
                    {{value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

    </div>


    <div style="text-align: center; padding-top: 50px">
      <ng-container *ngIf="submitted">
        <div style="justify-content: center; align-content: center; align-items: center; padding-bottom: 50px">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </ng-container>

      <div style="text-align: center">
        <ng-container *ngIf="!show">
          <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary">Invia!</button>
                <!--[disabled]="!qForm.valid"-->
        </ng-container>
      </div>
    </div>

  </form>
</div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
